var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-accessible-modal',{on:{"close":_vm.nextPrompt},scopedSlots:_vm._u([{key:"backdrop",fn:function(){return undefined},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }